import React from 'react'
import { Link } from 'react-router-dom'

class PageNav extends React.Component{

    state={
        currentPage:this.props.currentPage,
        pageList:this.props.pageList,
        totalPages:this.props.totalPages
    }

    render(){
        return(
            <nav aria-label="Page navigation" style={{alignContent:"center", justifyContent:"center", display:"flex"}}>
                        <ul className="pagination justify-content-end">
                            <li className={`page-item ${this.state.currentPage===1 && "disabled"}`}>
                                <Link 
                                    to="#"
                                    className="page-link" 
                                    tabIndex="-1" 
                                    aria-disabled={this.state.currentPage===1?false:true}
                                    onClick={this.props.onClickPrevious}
                                    >«</Link>
                            </li>

                            {this.state.pageList.map((item, key)=>
                                <li className={`page-item ${this.state.currentPage===item && "active"}`} key={key}>
                                    <Link to="#" 
                                        className="page-link" 
                                        onClick={()=>this.props.onClickPage(item)}>{item}</Link>
                                </li>)}
                           
                            <li className={`page-item ${this.state.currentPage===this.state.totalPages && "disabled"}`}>
                                <Link 
                                    to="#"
                                    className="page-link" 
                                    onClick={this.props.onClickNext}>»</Link>
                            </li>
                        </ul>
                    </nav>
           )
    }

}

export default PageNav